import { AmazonConnectApp } from "./amazon-connect-app";
import { AmazonConnectService } from "./service";

export type BaseProvider = AmazonConnectApp | AmazonConnectService;
